module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/VANITY-FAIR_S01.1566f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/VANITY-FAIR_S01.jpg
// module id = 5YnA
// module chunks = 0